import {SET_END_TIME_MODAL} from "../../types";

export function setParamsSetEndTimeModal(data) {
    return (dispatch) => {
        dispatch({type: SET_END_TIME_MODAL, payload: data});
    }
}
